import { Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Theme, useMediaQuery } from "@mui/material"
import { SettingTable, settingUseStyles } from "../Settings"
import TextCell from "./TextCell"
import { DbClusterStatus } from "neurotec-megamatcherid-management-client"
import { THEME } from "../../../config"

interface DatabaseTableProps {
    isMobile: boolean,
    dbClusterStatus: DbClusterStatus | undefined
}

const DatabaseTable: React.FC<DatabaseTableProps> = (props) => {

    const classes = settingUseStyles()
    const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

    const getColSpan = (): number => {
        if (props.isMobile)
            return 4;
        if (isSmall)
            return 3;
        return 2
    }

    const showTableRow = (name: string, value: string | undefined, color?: string) => {
        if (props.isMobile) {
            return (
                <TableRow>
                    <TableCell width={"50%"} colSpan={getColSpan()}>
                        {name}
                    </TableCell>
                    <TableCell colSpan={3} style={{color: color ?? undefined, fontWeight: color !== undefined ? 500 : 400}}>
                        {value ?? ""}
                    </TableCell>
                </TableRow>
            );
        } if (isSmall) {
            return (
                <TableRow>
                    <TableCell width={"50%"} colSpan={getColSpan()}>
                        {name}
                    </TableCell>
                    <TableCell colSpan={3} style={{color: color ?? undefined, fontWeight: color !== undefined ? 500 : 400}}>
                        {value ?? ""}
                    </TableCell>
                </TableRow>
            );
        } else {
            return (
                <TableRow>
                    <TableCell width={"25%"} colSpan={getColSpan()}>
                        {name}
                    </TableCell>
                    <TableCell colSpan={3} style={{color: color ?? undefined, fontWeight: color !== undefined ? 500 : 400}}>
                        {value ?? ""}
                    </TableCell>
                </TableRow>
            );
        }
    }

    return (
        <TableContainer component={Paper} className={classes.container}>
            <SettingTable>
                <TableHead>
                    <TableRow>
                        <TextCell head colspan={6} title="Database cluster status" subtitle="Shows if cluster is on and it's status"/>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={getColSpan()}>
                            Name
                        </TableCell>
                        <TableCell colSpan={3}>
                            Value
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {showTableRow("Status", props.dbClusterStatus?.ready, props.dbClusterStatus?.ready === "ON" ? THEME.palette.primary.main : THEME.palette.error.main)}
                    {props.dbClusterStatus?.ready === "ON" ? showTableRow("Size", props.dbClusterStatus?.clusterSize) : null}
                    {props.dbClusterStatus?.ready === "ON" ? showTableRow("Incoming addresses", props.dbClusterStatus?.incomingAddresses) : null}
                    {props.dbClusterStatus?.ready === "ON" ? showTableRow("UUID", props.dbClusterStatus?.localStateUuid): null}                    
                </TableBody>
            </SettingTable>
        </TableContainer>
    )
}

export default DatabaseTable